import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Warning = styled.div`
  padding: 16px 15px;
  border: ${({ theme }) => `1px solid ${theme.palette.system.red}`};
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.system.redToWhite};
  margin-bottom: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    border-radius: 0;
    margin-bottom: 0;
  }
`;

export const WarningTitle = styled(Typography.Header)`
  color: #fc433f;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const WarningDescription = styled(Typography.Caption).attrs(() => ({
  $variant: '2',
}))`
  color: ${({ theme }) => theme.palette.primary.labels};
`;
